export const ACCESSIBILITY_STORAGE_KEY =
  "portal_accessibility";

export const DEFAULT_FONT_SCALE = 1;

export const MIN_FONT_SCALE = 0.8;

export const MAX_FONT_SCALE = 1.4;

export const FONT_SCALE_STEP = 0.1;